import { appUrl } from "@/utils/app-url";
import { buildPaths as buildPagesPaths, Path as PathPages } from "./$path";
import {
  buildPaths as buildRoutePaths,
  Path as PathRoute,
} from "./$route-path";

export type PagesPath = PathPages;
/** @knipignore */
export type RoutePath = PathRoute;

export const pagesPath = buildPagesPaths(appUrl);
export const routePath = buildRoutePaths(appUrl);
